<template>
    <div>
        <textarea class="form-control form-control--mid" v-model="note.text" placeholder="Add note text">

        </textarea>
    </div>
</template>

<script>
import startups from "@/services/startups.service"
import ecosystems from "@/services/ecosystems.service"

export default {
    props: {
        companyType: String,
        companyId: Number,
    },

    data() {
        return {
            id: 0,

            note: {
                text: "",
            },
        }
    },

    watch: {
        "note.text"() {
            this.$emit('canSave', this.note.text.length > 0)
        }
    },

    methods: {
        init(id) {
            this.id = id
            this.note.text = ""

            if (this.id) {
                if (this.companyType == 'startup') {
                    startups.getNoteEdit(this.companyId, this.id).then(response => {
                        this.note = response.data
                    })
                } else {
                    ecosystems.getNoteEdit(this.companyId, this.id).then(response => {
                        this.note = response.data
                    })
                }
            }
        },

        save() {
            if (this.companyType == 'startup') {
                startups.saveNote(this.companyId, this.id, this.note).then(() => {
                    this.$emit('saved')
                })
            }
            else {
                ecosystems.saveNote(this.companyId, this.id, this.note).then(() => {
                    this.$emit('saved')
                })
            }
        },
    }
}
</script>

<style scoped>

</style>